import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import defFileIcon from '../../assets/defFile.svg';
import styles from './styles.module.scss';

const Thumbnail = ({uri = '', fileExtension = ''}) => {
  const link = `data:image/png;base64,${uri}`;

  return (
    <div className={classnames(styles.container, {[styles.pdfContainer]: fileExtension === 'pdf'})}>
      {Boolean(uri)
        ? <img src={link} alt={'thumbnail'}/>
        : <img src={defFileIcon} style={{width: 200}} alt={'thumbnail'}/>
      }
    </div>
  )
};

Thumbnail.propTypes = {
  uri: PropTypes.string,
  fileExtension: PropTypes.string,
};

export default Thumbnail;
